import React, { useState } from 'react';
import { TextInput, View } from 'react-native';
import MaterialIcon from 'react-native-vector-icons/MaterialIcons';

interface Props {
  initialValue?: string;
  placeholder?: string;
  onValueChange(value: string): void;
  disabled?: boolean;
  multiline?: boolean;
  style?: any;
}
const EditableText = ({
  initialValue,
  placeholder,
  onValueChange,
  disabled,
  style,
  multiline = true,
}: Props) => {
  const [scrollHeight, setScrollHeight] = useState<number | undefined>();
  return (
    <View style={{ position: 'relative', width: '100%' }}>
      <TextInput
        editable={!disabled}
        key={initialValue}
        defaultValue={initialValue}
        placeholder={placeholder}
        style={[
          { height: scrollHeight, padding: 2, paddingRight: 30, width: '100%' },
          style,
        ]}
        onContentSizeChange={(e) => {
          setScrollHeight(e.nativeEvent.contentSize.height);
        }}
        onBlur={(e: any) => onValueChange(e.target.value)}
        multiline={multiline}
      />
      {!disabled && (
        <View
          style={{
            position: 'absolute',
            top: 4,
            right: 4,
          }}
          pointerEvents="none"
        >
          <MaterialIcon name="edit" size={16} color="#999" />
        </View>
      )}
    </View>
  );
};

export default EditableText;
